module.exports = __webpack_public_path__ + "img/bellini.9c57c4f1.jpg";